import type { QuoteDocumentsResponse } from './api';

export const normalizeQuoteDocuments = (data: QuoteDocumentsResponse) => {
  if (!data) {
    return [];
  }
  return data;
};
